module.exports = __webpack_public_path__ + "img/loading2.237164b1.gif";